import React from "react";
import { Box, Typography, Button } from "@mui/material";
import BlockIcon from '@mui/icons-material/Block';
import { translations } from "../translations/common";
import { useAuth } from "../hooks/AuthProvider";

export const Forbidden: React.FC = () => {
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bgcolor="background.default"
      minHeight="100vh"
      p={3}
    >
      <BlockIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        {translations.forbidden.title}
      </Typography>
      <Typography variant="body1" color="textSecondary" gutterBottom sx={{ mb: 3, textAlign: 'center' }}>
        {translations.forbidden.message}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleLogout}
        size="large"
      >
        {translations.forbidden.logout}
      </Button>
    </Box>
  );
};
